import {
  jsonForm,
  get,
  formPost,
  formPut,
  urlPut,
  jsonDelete,
  formDelete,
} from '../utils/request';
// console.log(window.$intercept); 重要，此处可获取接口拦截转发前缀
// post json入参
// export const fetchData = (query) => {
//   return jsonPost('/table.json', query);
// };
// get入参
export const fetchData = (params) => {
  return get('/table.json', params);
};
// post 表单入参
// export const fetchData = (query) => {
//   return formPost('/table.json', query);
// };
export const getMenusData = (params) => {
  return get('/routerGaoji.json', {});
};
export const routerPutong = (params) => {
  return get('/routerPutong.json', {});
};
export const routerShenji = (params) => {
  return get('/routerShenji.json', {});
};
export const routerYonghu = (params) => {
  return get('/routerYonghu.json', {});
};

// 以下为真实开发
// 登录 --> 获取验证码
export const verifyCode = (params) => {
  return get(
    window.$intercept.intercept2 + '/loginController/verifyCode',
    params,
  );
};
// 登录 --> 登录
export const loginControllerLogin = (query) => {
  return formPost(window.$intercept.intercept2 + '/user/login', query);
};

// 登录
export const systemAvailabilityState = (query) => {
  return formPost(
    window.$intercept.intercept2 + '/stateController/systemAvailabilityState',
    query,
  );
};
// 退出登录 登出
export const logoutNew = (query) => {
  return formPost(
    window.$intercept.intercept2 + '/loginController/logoutNew',
    query,
  );
};
// 退出登录 修改密码
export const editUserPassword = (query) => {
  return formPost(
    window.$intercept.intercept2 + '/userController/editUserPassword',
    query,
  );
};
// 摄像头唤醒
export const hasopen = (query) => {
  return formPost(
    window.$intercept.intercept2 + '/node/hasopen ',
    query,
  );
};